import React from 'react'
import { Button } from 'reactstrap';
import { FormService } from './FormService';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { DeleteService } from './DeleteService';
import { Dialog } from 'primereact/dialog';

export const ModalService = (props) => {

    const {
        modal, modalTitle, closeDialog, method, loading,
        name, handleInputChange, validaciones,
        saveCreate, saveDelete, saveUpdate
    } = props;

    const footer = (
        <>


            <Button
                color="secondary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                disabled={loading}
                className={loading ? "progress-bar-animated progress-bar-striped" : ""}
            >
                {
                    loading
                        ? (
                            <>
                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                Guardando...
                            </>
                        )
                        : "Confirmar"
                }
            </Button>

            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
                disabled={loading}
            >
                Cancelar
            </Button>
        </>
    );

    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            modal
            blockScroll
            footer={footer}
            closable={false}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-ambulance f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>


                        </div>

                    </div>
                </div>
            }
            draggable={false}

            className={`Global-dialog Global-dialog Global-blue Global-small-v`}
        >
            {
                method === "create"
                    ? <FormService
                        button={ModalButtonSave}
                        {...{ loading, handleInputChange, validaciones, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ? <FormService button={ModalButtonUpdate} {...{ loading, handleInputChange, validaciones, methodAction: saveUpdate, name }} />
                        : null
            }
        </Dialog>
    )
}
